module.exports = __webpack_public_path__ + "img/66ac0d5caa494e0a688faa0431826fb9-exclamation.png";